<div class="col-lg-12 row">
    <div class="col-lg-12 ml-2 data-sect">
        <div class="col-lg-12">
            <h3>Fund Managers Images List</h3>
        </div>
        <hr>
        <table
            class="table"
            [svData]="data"
            #sv="svDataTable"
            [svRowsOnPage]="pageSize"
            *ngIf="data && data.length > 0"
        >
            <thead>
                <tr>
                    <th>Fund Manager</th>
                    <th
                        class="text-center"
                        width="10%"
                    >
                        View
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">
                    <td
                        [display]="item.names"
                        [tooltip]="item.names"
                        placement="top"
                        show-delay="300"
                    >
                        {{ item.names }}
                    </td>
                    <td class="text-center">
                        <img
                            src="assets/icons/icon_view.png"
                            class="cursor-pointer"
                            (click)="viewFile(item.imagePath)"
                        >
                    </td>



                </tr>
            </tbody>
            <tfoot *ngIf="data?.length > pageSize">
                <tr>
                    <td
                        colspan="5"
                        class="center-paginator"
                    >
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div *ngIf="data?.length <= 0">No Data found</div>
    </div>
</div>
